import { render, staticRenderFns } from "./Upsert.vue?vue&type=template&id=15080532&scoped=true"
import script from "./Upsert.vue?vue&type=script&lang=js"
export * from "./Upsert.vue?vue&type=script&lang=js"
import style0 from "./Upsert.vue?vue&type=style&index=0&id=15080532&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15080532",
  null
  
)

export default component.exports